<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Timeline } from 'ant-design-vue'
import { Empty } from '-/Common/Empty'
import StepResolve from '../common/StepResolve.vue'
import StepReject from '../common/StepReject.vue'
import StepLaunch from '../common/StepLaunch.vue'
const [name] = createNamespace('TimelineDetailZch')
enum STATUS_TYPE {
  FIRST_REJECT = '初审驳回',
  FIRST_APPROVE = '初审通过',
  FINAL_REJECT = '终审驳回',
  FINAL_APPROVE = '终审通过'
}
export default defineComponent({
  name,
  props: {
    record: {
      type: Object as PropType<any>
    }
  },
  setup(props) {
    const renderItem = (item: any, index: number) => {
      const isFirst = index === 0
      switch (item.type) {
        case STATUS_TYPE.FIRST_REJECT:
        case STATUS_TYPE.FINAL_REJECT:
          return <StepReject record={item} fileVisible={false} title={item.type} />
        case STATUS_TYPE.FIRST_APPROVE:
        case STATUS_TYPE.FINAL_APPROVE:
          return <StepResolve record={item} fileVisible={false} title={item.type} />
        default:
          return <StepLaunch record={item} isRenew={!isFirst} />
      }
    }
    const empty = computed(() => !props.record?.his?.length)
    return () => (empty.value ? <Empty /> : <Timeline>{props.record?.his?.map(renderItem)}</Timeline>)
  }
})
</script>
